// extracted by mini-css-extract-plugin
export default {"container":"SCi9eK9yNle9MWS3eD8M","label":"S7Y20yH_3qPrECSyIKhT","value":"ttSE7Wcf04Dnx7Tk6glV"};